export const DY_API_CAMPAIGN_SELECTOR_NAMES = {
  homeProductRecommendations: 'homepage-product-recommendations',
  pdpProductRecommendationsTop: 'pdp-product-recommendations-top',
  pdpProductRecommendationsBottom: 'pdp-product-recommendations-bottom',
  plpProductRecommendations: 'plp-product-recommendations',
  cartProductRecommendations: 'cart-product-recommendations',
  miniCartProductRecommendations: 'mini-cart-product-recommendations',
  narvarProductRecommendations: 'narvar-product-recommendations',
}
